<template>
  <div>
    <el-descriptions class="margin-top" title="" direction="vertical" :column="3" border>
      <el-descriptions-item>
        <template slot="label">活动名称 </template> {{ rowObj.name }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">检查日期 </template> {{ rowObj.check_date }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">检查对象</template> {{ rowObj.target_name }}
      </el-descriptions-item>
      <el-descriptions-item :span="3">
        <template slot="label">活动描述 </template> {{ rowObj.desc ? rowObj.desc : '无' }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">检查人员 </template> {{ rowObj.member_names }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">上报人员 </template> {{ rowObj.submit_name }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">上报时间 </template> {{ rowObj.submit_time }}
      </el-descriptions-item>
    </el-descriptions>
    <template v-if="rowObj.reports && rowObj.reports.length > 0">
      <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;padding:0 12px;">检查结果</p>
      <el-descriptions class="margin-top" title="" style="margin-bottom:16px;" :column="1" border>
        <el-descriptions-item v-for="(item, index) in rowObj.reports" :key="index">
          <template slot="label">{{ item.standard_name }} </template> {{ item.report_status_text }} {{
            item.target_name ? `(${item.target_name})` : '' }}
        </el-descriptions-item>
      </el-descriptions>
    </template>
  </div>
</template>
<script>
export default {
  props: ['rowObj'],
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>
